import { createContext } from "react";
import { DemoData } from "src/services/demo/queries/NetTypes";
import { ConnectedEntity } from "src/types/apps";

import { initial, State } from "./store";

export interface Actions {
	setStep: (val: number) => void;
	onSelectEntity: (val: ConnectedEntity) => void;
	onSendVerificationEmail: (val: string) => void;
	onSetSessionToken: (val: string) => void;
	onConnectAccount: (val: string) => void;
	onDemoFinished: (val: DemoData) => void;
}

export interface ContextType {
	type: string;
	state: State;
	actions: Actions;
}

const defaultContextValues: ContextType = {
	type: "",
	state: initial,
	actions: {
		setStep: () => {},
		onSelectEntity: () => {},
		onSendVerificationEmail: () => {},
		onSetSessionToken: () => {},
		onConnectAccount: () => {},
		onDemoFinished: () => {}
	}
};

export default createContext<ContextType>(defaultContextValues);
